import { c as _c } from "react/compiler-runtime";
import { type JSX, useState } from 'react';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
type FormWizardProps = {
  Component: (step: StepProps) => JSX.Element;
  defaultValues: FormData;
  id: string;
  isLastStep: boolean;
  onForward: () => void;
  onSubmit: (formData: FormData) => void;
};
const FormWizard = t0 => {
  const $ = _c(10);
  const {
    Component,
    defaultValues,
    id,
    isLastStep,
    onSubmit,
    onForward
  } = t0;
  const [formData, setFormData] = useState(defaultValues);
  let t1;
  if ($[0] !== formData || $[1] !== isLastStep || $[2] !== onForward || $[3] !== onSubmit) {
    t1 = newData => {
      setFormData(prevData => ({
        ...prevData,
        ...newData
      }));
      if (isLastStep) {
        const payload = {
          ...formData,
          ...newData
        };
        onSubmit(payload);
      } else {
        onForward();
      }
    };
    $[0] = formData;
    $[1] = isLastStep;
    $[2] = onForward;
    $[3] = onSubmit;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleSubmit = t1;
  let t2;
  if ($[5] !== Component || $[6] !== formData || $[7] !== handleSubmit || $[8] !== id) {
    t2 = <Component id={id} onSubmit={handleSubmit} values={formData} />;
    $[5] = Component;
    $[6] = formData;
    $[7] = handleSubmit;
    $[8] = id;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default FormWizard;